import moment from 'moment';

function controller($scope, $window, $timeout, tax, finance, benefits, plans, wbConfig, toggle, locale) {
  // Very hackish way to make timelines fit
  function getTimelineWidth() {
    $scope.timelineWidth = $('.plan-component-timeline').width();
    return $scope.timelineWidth;
  }
  toggle.register($scope)

  const frenchDebtTypes = {
    1: "Hypothèque",
    2: "Prêt/crédit",
    3: "Autre dette"
  }

  const frenchAssetTypes = {
    1: "REER",
    2: "CELI",
    3: "Autre Compte",
    4: "Immobilier",
    5: "Autre Actif",
    6: "REEE",
  }

  const assetTypes = ['', 'rrsp', 'tfsa', 'other', 'house', 'otherAsset', 'resp'];
  this.details = {};
  this.config = wbConfig;
  this.options = {
    inflation: 0.02,
    hasSpouse: false,
    province: 'BC',
    self: {
      age: 35,
      dob: '1980-02-01',
      clientProfileSync: false,
      retirementAge: 65,
      income: 100000,
    },
    spouse: {
      age: 35,
      retirementAge: 65,
      income: 0,
    },
    benefits: {
      defaultCpp: true,
      defaultOas: false,
      pension: 0,
      pensionStart: 65,
      cpp: 0,
      cppStart: 65,
      oas: 0,
      oasStart: 65,
    },
    retirement: {
      defaultLifestyle: true,
      lifestyleMonthly: 0,
    },
  };

  this.chartsSection = 'projectedSavings';
  this.modelOptions = {
    debounce: 400,
  };
  this.amountType = 'monthly';

  $scope.getName = (key, value) => `${key}-name-${value.name}-type-${value.type}`;

  function calculateBenefits(options, retirementIncome) {
    if (options.benefits.defaultCPP) {
      let cpp = benefits.calculateCPP(options.self.income, options.benefits.cppStart);
      if (options.hasSpouse) {
        cpp += benefits.calculateCPP(options.spouse.income, options.benefits.cppStart);
      }
      options.benefits.cpp = cpp;
    }
    if (options.benefits.defaultOAS) {
      let oas;
      if (options.hasSpouse) {
        oas = 2 * benefits.calculateOAS(retirementIncome / 2, options.benefits.oasStart);
      } else {
        oas = benefits.calculateOAS(retirementIncome, options.benefits.oasStart);
      }
      options.benefits.oas = oas;
    }
  }

  const calculateDetails = options => {
    const income = options.self.income + (options.hasSpouse ? options.spouse.income : 0);
    let selfNetIncome = options.self.income;
    let spouseNetIncome = options.spouse.income;
    let savings = 0;
    let debts = 0;
    for (const k in options.assets) {
      const v = options.assets[k];
      savings += v.payment * 12;
    }
    for (const k in options.debts) {
      const v = options.debts[k];
      debts += v.payment * 12;
    }
    let rrspMonthlyTotal = 0;
    let rrspMonthlyTotalSpouse = 0;
    for (const k in options.assets) {
      const v = options.assets[k];
      if (+v.type === 1) {
        if (v.spouse === true) rrspMonthlyTotalSpouse += v.payment;
        else rrspMonthlyTotal += v.payment;
      }
    }

    const selfBenefitContributions = benefits.getAllContributions(options.self.income, options.province);
    selfNetIncome -= selfBenefitContributions;
    const spouseBenefitContributions = benefits.getAllContributions(options.spouse.income, options.province);
    spouseNetIncome -= spouseBenefitContributions;
    const benefitContributions = selfBenefitContributions + (options.hasSpouse ? spouseBenefitContributions : 0);

    let selfTaxes = tax.getTaxes(options.self.income, options.province);
    selfTaxes -= benefits.calculateTaxCredit(options.self.income, options.province);
    const selfRrspReturn =
      tax.getTaxDeduction(options.self.income,
        rrspMonthlyTotal * 12,
        options.province);
    selfTaxes -= selfRrspReturn;

    let spouseTaxes = tax.getTaxes(options.spouse.income, options.province);
    spouseTaxes -= benefits.calculateTaxCredit(options.spouse.income, options.province);
    const spouseRrspReturn = tax.getTaxDeduction(options.self.income,
      rrspMonthlyTotalSpouse * 12,
      options.province);
    spouseTaxes -= spouseRrspReturn;

    const rrspReturn = selfRrspReturn + (options.hasSpouse ? spouseRrspReturn : 0);
    const taxes = selfTaxes + (options.hasSpouse ? spouseTaxes : 0);

    selfNetIncome -= selfTaxes;
    spouseNetIncome -= spouseTaxes;

    const currentLifestyle = (selfNetIncome + (options.hasSpouse ? spouseNetIncome : 0)) - (savings + debts);
    let retirementLifestyle = 0;

    if (options.retirement.defaultLifestyle) {
      retirementLifestyle = currentLifestyle;
      options.retirement.lifestyleMonthly = +(currentLifestyle / 12).toFixed(2);
    } else {
      retirementLifestyle = options.retirement.lifestyleMonthly * 12;
    }

    const retirementTaxes = options.hasSpouse ?
      (2 * tax.getGrossIncomeFromNet(retirementLifestyle / 2, options.province)) - currentLifestyle :
      tax.getGrossIncomeFromNet(retirementLifestyle, options.province) - currentLifestyle;

    this.projectedSavings = [{
      category: 'Savings',
      amount: (savings / 12),
      percent: savings / income,
    }, {
      category: 'Benefits',
      amount: (benefitContributions / 12),
      percent: benefitContributions / income,
    }, {
      category: 'Debts',
      amount: (debts / 12),
      percent: debts / income,
    }, {
      category: 'Taxes',
      amount: (taxes / 12),
      percent: taxes / income,
    }, {
      category: 'Lifestyle',
      amount: (currentLifestyle / 12),
      percent: currentLifestyle / income,
    }];

    const retirementYear = new Date().getFullYear() + (options.self.retirementAge - this.getAge(options.self.dob));
    const endOfPlanYear = new Date().getFullYear() + (100 - this.getAge(options.self.dob));
    const retirementMonth = moment(options.self.dob).format('MMMM');

    return {
      income,
      netIncome: selfNetIncome + (options.hasSpouse ? spouseNetIncome : 0),
      selfNetIncome,
      spouseNetIncome,
      savings,
      debts,
      taxes,
      benefitContributions,
      taxesAndDeductions: taxes + benefitContributions,
      currentLifestyle,
      retirementLifestyle,
      retirementTaxes,
      retirementYear,
      retirementMonth,
      endOfPlanYear,
      rrspReturn,
    };
  };

  const executePlan = options => {
    if (!options || ($scope.optionsForm == null) || !$scope.optionsForm.$valid) {
      return;
    }
    this.details = calculateDetails(options);

    const plan = plans.createFinancialPlan({
      start: this.getAge(options.self.dob) * 12,
    });

    // Reorder assets
    options.assets = _.sortBy(options.assets, 'type');

    for (const k in options.assets) {
      let depositFactor;
      const v = options.assets[k];
      const accountName = $scope.getName(k, v);
      if (v.type <= 3) {
        if (this.details.savings > 0) {
          depositFactor = (v.payment * 12) / this.details.savings;
        } else {
          depositFactor = 0;
        }
        plan.addAccount(accountName, {
          balance: v.balance || 0,
          depositFactor,
          type: 'account',
          assetType: assetTypes[v.type],
          rate: finance.realRateOfReturn(v.interestRate, options.inflation),
        });
      } else {
        plan.addAccount(accountName, {
          balance: v.balance || 0,
          depositFactor: 0,
          type: 'asset',
          assetType: assetTypes[v.type],
          rate: finance.realRateOfReturn(v.interestRate, options.inflation),
        });
      }
    }

    let income = options.self.income;
    if (options.hasSpouse) {
      income += options.spouse.income;
    }
    plan.addIncome('income', {
      payment: income,
      paymentsPerYear: 1,
      start: this.getAge(options.self.dob) * 12,
      end: this.getRetirementMonth(options.self.retirementAge, options.self.dob),
    });

    calculateBenefits(options, this.details.retirementLifestyle + this.details.retirementTaxes);
    plan.addIncome('cpp', {
      payment: options.benefits.cpp,
      paymentsPerYear: 1,
      start: options.benefits.cppStart * 12,
    });
    plan.addIncome('oas', {
      payment: options.benefits.oas,
      paymentsPerYear: 1,
      start: options.benefits.oasStart * 12,
    });
    plan.addIncome('pension', {
      payment: options.benefits.pension,
      paymentsPerYear: 1,
      start: options.benefits.pensionStart * 12,
    });

    for (const k in options.debts) {
      const v = options.debts[k];
      const debtName = $scope.getName(k, v);
      const rate = v.type === 1 ?
        finance.cdnMortgageRate(v.interestRate) :
        v.interestRate;
      if (!v.balance) {
        v.balance = 0;
      }
      if (!v.payment) {
        v.payment = 0;
      }
      plan.addDebt(debtName, {
        balance: v.balance,
        payment: v.payment,
        rate,
        start: this.getAge(options.self.dob) * 12,
      });
    }

    plan.addExpense('currentLifestyle', {
      payment: this.details.currentLifestyle,
      paymentsPerYear: 1,
      start: this.getAge(options.self.dob) * 12,
      end: this.getRetirementMonth(options.self.retirementAge, options.self.dob),
    });

    plan.addExpense('taxesAndDeductions', {
      payment: this.details.taxesAndDeductions,
      paymentsPerYear: 1,
      start: this.getAge(options.self.dob) * 12,
      end: this.getRetirementMonth(options.self.retirementAge, options.self.dob),
    });

    plan.addExpense('retirementLifestyle', {
      payment: this.details.retirementLifestyle,
      paymentsPerYear: 1,
      start: this.getRetirementMonth(options.self.retirementAge, options.self.dob),
    });

    plan.addExpense('retirementTaxes', {
      payment: this.details.retirementTaxes,
      paymentsPerYear: 1,
      start: this.getRetirementMonth(options.self.retirementAge, options.self.dob),
    });

    this.accountColumns = _(plan.accounts).pickBy(a => a.type === 'account').keys().value();
    this.results = plan.execute();

    const retirementData = _.find(this.results, { month: (this.getRetirementMonth(this.options.self.retirementAge, this.options.self.dob)) - 1 });
    if (retirementData) this.retirementSavings = retirementData.savings;
    this.savingsDepleted = _.find(this.results, { savings: 0 });
    this.isInsufficient = (this.savingsDepleted != null ? this.savingsDepleted.year : undefined) < 99;
    getTimelineWidth();
  };

  $scope.calculateYearsLeft = budgetItem => {
    if (budgetItem == null) return 0;
    const months = finance.periods(
      finance.cdnMortgageRate(budgetItem.interestRate) / 12,
      budgetItem.payment,
      budgetItem.balance,
    );
    let years = (months / 12) + this.getAge(this.options.self.dob);
    if (_.isNaN(years) || years > 100) {
      years = 100;
    }
    return Math.round(years);
  };

  angular.element($window).bind('resize', getTimelineWidth);

  $scope.calculateTimelineWidth = budgetItem => {
    if (budgetItem == null) return getTimelineWidth();
    const budgetYears = $scope.calculateYearsLeft(budgetItem) - this.getAge(this.options.self.dob);
    const maxYears = 100 - this.getAge(this.options.self.dob);
    const years = Math.min(budgetYears, maxYears);
    const oneYearWidth = getTimelineWidth() / (100 - this.getAge(this.options.self.dob));
    return (oneYearWidth * years) + 4;
  };

  $scope.calculateTimelineToRetirementWidth = asset => {
    if (asset.payment === 0) return 0;
    const years = this.options.self.retirementAge - this.getAge(this.options.self.dob);
    const oneYearWidth = getTimelineWidth() / (100 - this.getAge(this.options.self.dob));
    return (oneYearWidth * years) + 4;
  };

  $scope.hideOverlay = () => {
    // This should be refactored to not refer to the DOM in the future
    $timeout((() => angular.element('#overlayAxis').trigger('click')), 100);
    return false;
  };

  this.addAsset = (type, name) => {
    toggle.toggle($scope)
    if (this.options.assets == null) {
      this.options.assets = [];
    }
    let interestRate = 0.02;
    if (type <= 2) interestRate = 0.06;
    if (type === 3) interestRate = 0.04;
    if (type === 6) interestRate = 0.055;
    return this.options.assets.push({
      type,
      typeName: name,
      name: locale.isFrench() ? `Mon ${frenchAssetTypes[type]}` : `My ${name}`,
      balance: 0,
      payment: 0,
      interestRate,
    });
  };

  this.addDebt = (type, name) => {
    toggle.toggle($scope)
    if (this.options.debts == null) {
      this.options.debts = [];
    }
    return this.options.debts.push({
      type,
      typeName: name,
      name: locale.isFrench() ? `Mon ${frenchDebtTypes[type]}` : `My ${name}`,
      balance: 0,
      payment: 0,
      interestRate: 0.03,
    });
  };

  this.removeAsset = asset => _.remove(this.options.assets, asset);

  this.removeDebt = debt => _.remove(this.options.debts, debt);

  this.getBalanceTotal = accounts => {
    if (accounts == null) return 0;
    let total = 0;
    for (const account of Array.from(accounts)) {
      total += account.balance;
    }
    return total;
  };

  this.calculateMonthlyNet = () => {
    const self = this.details.selfNetIncome;
    const spouse = this.details.spouseNetIncome;
    if (this.options.hasSpouse) {
      return (self / 12) + (spouse / 12);
    }
    return (self / 12);
  };

  const getChartLegendMonth = () => {
    if (this.selectedDataPoint == null) return null;
    const today = new Date();
    const months = this.selectedDataPoint.month - (this.getAge(this.options.self.dob) * 12);
    return today.setMonth(today.getMonth() + months);
  };

  const getChartLegendBalances = () => {
    const balances = [];
    for (const k in this.options.assets) {
      const v = this.options.assets[k];
      const accountName = $scope.getName(k, v);
      balances.push({
        name: v.name,
        balance: this.selectedDataPoint[accountName],
      });
    }
    for (const k in this.options.debts) {
      const v = this.options.debts[k];
      const accountName = $scope.getName(k, v);
      balances.push({
        name: v.name,
        balance: this.selectedDataPoint[accountName],
      });
    }
    return balances;
  };

  this.getChartLegendPosition = (xpos, ypos) => {
    if (this.selectedDataPoint == null) {
      return {};
    }
    if ((this.selectedDataPoint.year - this.getAge(this.options.self.dob)) > ((100 - this.getAge(this.options.self.dob)) / 2)) {
      return {
        top: ypos - 22,
        left: xpos - 250 - 22,
      };
    }
    return {
      top: ypos - 22,
      left: xpos + 22,
    };
  };

  this.getDataPoint = (x) => {
    if (!this.results) {
      return [];
    }
    const point = _.binarySearch(this.results, data => x - data.year);
    this.selectedDataPoint = point;
    this.chartLegendBalances = getChartLegendBalances();
    this.chartLegendMonth = getChartLegendMonth();
    return [point.year, point.savings];
  };

  this.getAge = (dateOfBirth) => moment().diff(dateOfBirth, 'years');

  // This will calculate and return the number of months from today to the retirement date used for the graph
  this.getRetirementMonth = (retirementAge, dateOfBirth) => {
    const retirementCalendarDate = moment(dateOfBirth).add(retirementAge, 'years');
    const numberOfMonthsToRetirement = retirementCalendarDate.diff(moment(dateOfBirth), 'months', true) - moment().month();
    return numberOfMonthsToRetirement;
  };

  $scope.$watch('ctrl.options', executePlan, true);

  let init = false;
  $scope.$watch('plan', plan => {
    if (init === true) { return; }
    if (plan == null) { return; }
    this.options = _.defaultsDeep(plan, this.options);
    init = true;
  });
}

angular.module('wbControllers').controller('NewFinancialPlanController', [
  '$scope', '$window', '$timeout', 'tax', 'finance', 'benefits', 'financialPlans', 'wbConfig', 'toggle', 'locale', controller,
]);
